import { openRequirementResultDialog } from "features/requirements/helpers/requirementResultDialogHelper";
import IRequirementCreateService from "features/requirements/services/IRequirementCreateService";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import React from "react";
import BasicInfoSubFormSection from "features/requirements/sections/requirementFormTypes/basicInfoSubForm/BasicInfoSubFormSection";
import { useForm } from "features/shared/forms/hooks/useForm";
import { useTranslationWithPrefix } from "features/shared/hooks/useTranslationWithPrefix";
import { generalRequirementFormValidations } from "./generalRequirementFormValidation";

type Props = {
  requirementType: string;
  title: string;
};

const GeneralRequirementFormSection = ({ requirementType, title }: Props) => {
  // translations
  const tLabels = useTranslationWithPrefix(
    "requirements\\requirements",
    "generalRequirementFormSection"
  );

  // DI
  const createService = useInjection<IRequirementCreateService>(
    IocTypes.RequirementCreateService
  );

  // form hook
  const {
    values,
    errors,
    bindField,
    bindUncontrolledField,
    valideteForm,
    setValidationRule,
  } = useForm({
    initialValidations: generalRequirementFormValidations(),
  });

  // handlers
  const submitFormHandler = async (e: React.FormEvent) => {
    e.preventDefault();
    if (valideteForm()) {
      let result = await createService.createRequirement(
        requirementType as any,
        values
      );

      openRequirementResultDialog(false, { response: result });
    }
  };

  // render
  return (
    <form onSubmit={submitFormHandler}>
      <BasicInfoSubFormSection
        bindField={bindField}
        bindUncontrolledField={bindUncontrolledField}
        errors={errors}
        setValidationRule={setValidationRule}
        enableDescription
        cardTitle={title}
      />

      <button type="submit" className="btn btn-primary px-3 py-2">
        {tLabels("sendRequirement")}
      </button>
    </form>
  );
};

export default GeneralRequirementFormSection;
